module.exports = __webpack_public_path__ + "static/media/arrow-right.ca4d74f3.svg";